import { getFatoColor, getFatoLabel } from '@components/map/layers/vertiports/vertiport.utils';
import { ColorLabelEnum, iconColor } from '@utils/map/map.constants';
import { toLonLatArray } from '@utils/validation/coordinates.utils';
import { Feature, GeoJsonProperties } from 'geojson';
import { PointFeature } from 'supercluster';

import { Fato, Vertiport } from '@/types/intercom/intercom.types';
import { FeatureTypeEnum } from '@/types/map.types';

type FatoProperties = {
  featureType: FeatureTypeEnum;
  id: string;
  value: Fato;
  label: string;
  icon: string;
} & GeoJsonProperties;

function toFatoFeature(fato: Fato): PointFeature<FatoProperties> {
  return {
    type: 'Feature',
    id: `${FeatureTypeEnum.FATO_ICON}-${fato.code}`,
    properties: {
      featureType: FeatureTypeEnum.FATO_ICON,
      id: fato.code,
      value: fato,
      label: getFatoLabel(fato.type, fato.number),
      icon: `icSymb-cluster-${iconColor[getFatoColor(fato.state) as ColorLabelEnum]}`,
    },
    geometry: {
      type: 'Point',
      coordinates: toLonLatArray(fato.position)!,
    },
  };
}

function toFatoFeatures(fatos: Fato[]): Feature[] {
  return fatos.map((fato) => toFatoFeature(fato));
}

export function toAllFatoFeatures(vertiports: Vertiport[]): Feature[] {
  return vertiports.flatMap((vertiport) => toFatoFeatures(vertiport.fatos));
}
